import {
  FaTachometerAlt, FaTruckLoading, FaTruck, FaClipboardList, FaFileInvoiceDollar,
  FaMoneyBillWave, FaChartPie, FaUserShield, FaUsers, FaWarehouse, FaUserCog, FaBars, FaShoppingCart, FaShippingFast,
  FaBox, FaCalendarAlt, FaCalendarCheck, FaShoppingBag, FaBoxes, FaHandshake
} from 'react-icons/fa';

export const iconMap = {
  FaTachometerAlt,
  FaTruckLoading,
  FaTruck,
  FaClipboardList,
  FaFileInvoiceDollar,
  FaMoneyBillWave,
  FaChartPie,
  FaUserShield,
  FaUsers,
  FaWarehouse,
  FaUserCog,
  FaBars,
  FaShoppingCart,
  FaShippingFast,
  FaBox,
  FaCalendarAlt,
  FaCalendarCheck,
  FaShoppingBag,
  FaBoxes,
  FaHandshake
};

export const MENU_INTERNAL = {
  items: [
    { path: '/dashboard', icon: 'FaTachometerAlt', label: 'Dashboard' },
    { path: '/calendar', icon: 'FaCalendarAlt', label: 'Calendar' },
    { path: '/purchase-orders', icon: 'FaClipboardList', label: 'Purchase Orders' },
    { path: '/receipts', icon: 'FaTruckLoading', label: 'Warehouse Receipts' },
    { path: '/orders', icon: 'FaTruck', label: 'Orders' },
    { path: '/eorders', icon: 'FaShoppingBag', label: 'eOrders' },
    { path: '/clients', icon: 'FaUsers', label: 'Clients' },
    {
      type: 'group',
      key: 'inventory',
      icon: 'FaWarehouse',
      label: 'Inventory',
      rootPath: '/inventory',
      children: [
        { path: '/inventory', icon: 'FaWarehouse', label: 'Inventory' },
        { path: '/picking-replenishment', icon: 'FaBoxes', label: 'Picking Replenishment' },
      ],
    },

    // New group for Items + Bundles
    {
      type: 'group',
      key: 'items',
      icon: 'FaBars',
      label: 'Item / SKUs',
      rootPath: '/items',
      children: [
        { path: '/items', icon: 'FaBars', label: 'Item Maintenance' },
        { path: '/bundles', icon: 'FaBars', label: 'Bundles' },
      ],
    },

    { path: '/warehouse', icon: 'FaWarehouse', label: 'Warehouse' },
    {
      type: 'group',
      key: 'invoices',
      icon: 'FaFileInvoiceDollar',
      label: 'Invoicing',
      rootPath: '/invoices',
      children: [
        { path: '/invoices', icon: 'FaFileInvoiceDollar', label: 'Invoices' },
        { path: '/payments', icon: 'FaMoneyBillWave', label: 'Payments' },
        { path: '/invoices-periodic', icon: 'FaCalendarAlt', label: 'Periodic Invoicing' },
        { path: '/invoices-weekly', icon: 'FaCalendarAlt', label: 'Weekly Invoicing' },
        { path: '/invoices-monthly', icon: 'FaCalendarCheck', label: 'Monthly Invoicing' },
      ],
    },
    {
      type: 'group',
      key: 'admin',
      icon: 'FaUserShield',
      label: 'Administration',
      rootPath: '/users',
      requiresAdmin: true,
      children: [
        { path: '/server-status', icon: 'FaTachometerAlt', label: 'Server Status' },
        { path: '/appconfig', icon: 'FaUserCog', label: 'App Config' },
        { path: '/users', icon: 'FaUserCog', label: 'Users' },
        { path: '/suppliers', icon: 'FaHandshake', label: 'Suppliers' },
        { path: '/carriers', icon: 'FaTruck', label: 'Carriers' },
        {
          type: 'group',
          key: 'warehouses',
          icon: 'FaWarehouse',
          label: 'Warehouses',
          rootPath: '/warehouse-config',
          children: [
            { path: '/warehouse-config', icon: 'FaWarehouse', label: 'Warehouse Config' },
            { path: '/warehouse-designer', icon: 'FaWarehouse', label: 'Warehouse Layouts' },
            {
              type: 'group',
              key: 'warehousefees',
              icon: 'FaMoneyBillWave',
              label: 'Warehouse Fees',
              rootPath: '/templates/warehousefees',
              children: [
                { path: '/templates/warehousefees', icon: 'FaWarehouse', label: 'Storage Fees' },
                { path: '/templates/receiptfees', icon: 'FaTruckLoading', label: 'Receipt Fees' },
                { path: '/templates/orderfees', icon: 'FaTruck', label: 'Order Fees' },
                { path: '/templates/eorderfees', icon: 'FaShoppingBag', label: 'eOrder Fees' },
                { path: '/templates/customfees', icon: 'FaClipboardList', label: 'Custom Fees' },
              ],
            },
          ],
        },
        { path: '/shoppingintegrations', icon: 'FaShoppingCart', label: 'Shopping Integrations' },
        {
          type: 'group',
          key: 'shipping',
          icon: 'FaShippingFast',
          label: 'Shipping',
          rootPath: '/shippingintegrations',
          children: [
            { path: '/shippingintegrations', icon: 'FaShippingFast', label: 'Shipping Integrations' },
            { path: '/shipping-funding', icon: 'FaMoneyBillWave', label: 'Shipping Funding' },
            { path: '/shipping-packages', icon: 'FaBox', label: 'Package/Box Definitions' },
          ],
        },
      ],
    },
    { path: '/reports', icon: 'FaChartPie', label: 'Reports' },
  ]
};

export const MENU_CLIENT = {
  items: [
    { path: '/dashboard', icon: 'FaTachometerAlt', label: 'Dashboard' },
    { path: '/purchase-orders', icon: 'FaClipboardList', label: 'Purchase Orders' },
    { path: '/receipts', icon: 'FaTruckLoading', label: 'Warehouse Receipts' },
    { path: '/orders', icon: 'FaTruck', label: 'Orders' },
    { path: '/eorders', icon: 'FaShoppingBag', label: 'eOrders' },
    // New group for Items + Bundles (client view)
    {
      type: 'group',
      key: 'items',
      icon: 'FaBars',
      label: 'Item / SKUs',
      rootPath: '/items',
      children: [
        { path: '/items', icon: 'FaBars', label: 'Item Maintenance' },
        { path: '/bundles', icon: 'FaBars', label: 'Bundles' },
      ],
    },

    { path: '/inventory', icon: 'FaWarehouse', label: 'Inventory' },
    { path: '/invoices', icon: 'FaFileInvoiceDollar', label: 'Invoices' },
    { path: '/reports', icon: 'FaChartPie', label: 'Reports' },
  ]
};
